import i18n from "@/i18n";

export default [
  {
    image: require("@/assets/images/cars/i10.png"),
    text: i18n.t("car-models.i10"),
    id: 53226
  },
  {
    image: require("@/assets/images/cars/i20.png"),
    text: i18n.t("car-models.i20"),
    id: 279958
  },
  {
    image: require("@/assets/images/cars/ix20.png"),
    text: i18n.t("car-models.ix20"),
    id: 293910
  },
  {
    image: require("@/assets/images/cars/i30_hatchback.png"),
    text: i18n.t("car-models.i30-hatchback"),
    id: "53227-56015"
  },
  {
    image: require("@/assets/images/cars/i30_fastback.png"),
    text: i18n.t("car-models.i30-fastback"),
    id: "53227-56000"
  },
  {
    image: require("@/assets/images/cars/i30_tourer.png"),
    text: i18n.t("car-models.i30-tourer"),
    id: "53227-56010"
  },
  {
    image: require("@/assets/images/cars/Bayon.png"),
    text: i18n.t("car-models.bayon"),
    id: 310880
  },
  {
    image: require("@/assets/images/cars/ix35.png"),
    text: i18n.t("car-models.ix35"),
    id: 293301
  },
  {
    image: require("@/assets/images/cars/i40_saloon.png"),
    text: i18n.t("car-models.i40-saloon"),
    id: "294090-56000"
  },
  {
    image: require("@/assets/images/cars/i40_tourer.png"),
    text: i18n.t("car-models.i40-tourer"),
    id: "294090-56010"
  },
  {
    image: require("@/assets/images/cars/ioniq.png"),
    text: i18n.t("car-models.ioniq"),
    id: 300653
  },
  {
    image: require("@/assets/images/cars/IONIQ5.png"),
    text: i18n.t("car-models.ioniq-5"),
    id: 311077
  },
  {
    image: require("@/assets/images/cars/IONIQ6.png"),
    text: i18n.t("car-models.ioniq-6"),
    id: 313587
  },
  {
    image: require("@/assets/images/cars/ioniq-9.png"),
    text: i18n.t("car-models.ioniq-9"),
    id: 314682
  },
  {
    image: require("@/assets/images/cars/kona.png"),
    text: i18n.t("car-models.kona"),
    id: 304395
  },
  {
    image: require("@/assets/images/cars/tucson.png"),
    text: i18n.t("car-models.tucson"),
    id: 52899
  },
  {
    image: require("@/assets/images/cars/santa_fe.png"),
    text: i18n.t("car-models.santa-fe"),
    id: 51175
  },
  {
    image: require("@/assets/images/cars/veloster.png"),
    text: i18n.t("car-models.veloster"),
    id: 294236
  },
  {
    image: require("@/assets/images/cars/staria-van.png"),
    text: i18n.t("car-models.staria-van"),
    id: 314681
  },
  {
    image: require("@/assets/images/cars/inster.png"),
    text: i18n.t("car-models.inster"),
    id: 314683
  }
].sort((a, b) => a.text.localeCompare(b.text));
